/**
 * PATH: packages/email-hub/src/feature/lib/junkTargets.ts
 * FILE_ID: EMAILHUB-JUNKTARGETS-001
 * PURPOSE: Pure I → O helper that splits an email's from-address into
 *          the two values an auto-junk rule can match on: the exact
 *          sender address and its domain.
 * WHY:     The "Junk options" affordance (JunkButton + the right-click
 *          "Junk & auto-trash" submenu) both need to offer "just this
 *          sender" vs "whole domain". Centralising the split keeps the
 *          two surfaces identical and unit-testable without React.
 * FLOW:
 *   ┌──────────────┐   ┌──────────────────────┐   ┌────────────────┐
 *   │ from_address │ → │ lower + split on '@' │ → │ {exact, domain}│
 *   └──────────────┘   └──────────────────────┘   └────────────────┘
 * RELATED:
 *   - ../components/JunkButton.tsx (consumer)
 *   - ../hooks/useEmails.ts (createAutoJunkRule — the mutation armed)
 */

/** Split a from-address into its exact + domain junk-match values.
 *  Returns empty strings when the address is missing / malformed so the
 *  caller can HIDE the option rather than arm a rule that would match
 *  everything. */
export function deriveJunkTargets(
  fromAddress: string | null | undefined,
): { exact: string; domain: string } {
  const addr = (fromAddress ?? '').trim().toLowerCase()
  if (!addr.includes('@')) return { exact: '', domain: '' }
  const domain = addr.split('@')[1] ?? ''
  return { exact: addr, domain }
}
